// extracted by mini-css-extract-plugin
export default {"component":"SectionLabel_component__v4dHJ"};